var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"router-fade","mode":"out-in"}},[_c('div',{staticClass:"app",attrs:{"onbeforeunload":"ZMtj","id":"app"}},[_c('header-v1'),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }